export default [
  {
    path: '/modules/report',
    redirect: '/modules/report/financial',
    name: 'reportPageFinancial',
    component: () => import('@/views/modules/report/Report.vue'),
    meta: {
      action: 'ROLE_RELATORIO_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Relatórios',
      breadcrumb: [
        {
          text: 'financial'
        }
      ]
    },
    children: [
      {
        path: 'financial',
        name: 'financial',
        component: () => import('@/views/modules/report/Report.vue'),
        meta: {
          pageTitle: 'Relatórios',
          action: 'ROLE_RELATORIO_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Financeiro | Relatórios'
            }
          ]
        }
      }
    ]
  }
]
